/* ---- 服务中心（系统运营）模拟数据 ---- */

// 系统用户概览
export const SYSTEM_USER_OVERVIEW = {
  period: '2026年5月1日 - 2026年6月5日',
  totalUsers: 3256,
  activeUsers: 2847,
  newUsersThisMonth: 128,
  totalLogins: 18456,
  totalReportsViewed: 89234,
  totalReportsCreated: 12567,
  avgSessionDuration: '12m 35s',
  peakConcurrentUsers: 342,
}

// 近8周活跃趋势
export const WEEKLY_ACTIVITY = [
  { week: '第18周', logins: 2156, reportsViewed: 11230, reportsCreated: 1520 },
  { week: '第19周', logins: 2340, reportsViewed: 12100, reportsCreated: 1680 },
  { week: '第20周', logins: 2480, reportsViewed: 13050, reportsCreated: 1890 },
  { week: '第21周', logins: 2290, reportsViewed: 11800, reportsCreated: 1650 },
  { week: '第22周', logins: 2520, reportsViewed: 13450, reportsCreated: 1920 },
  { week: '第23周', logins: 2680, reportsViewed: 14200, reportsCreated: 2010 },
  { week: '第24周', logins: 2590, reportsViewed: 13680, reportsCreated: 1860 },
  { week: '第25周', logins: 2400, reportsViewed: 9724, reportsCreated: 1037 },
]

// 机构活跃度 — 支持总行部门、分行、支行三级
export interface OrgActivity {
  id: string
  name: string
  level: 'head-dept' | 'branch' | 'sub-branch'
  userCount: number
  activeUsers: number
  activeRate: number
  reportsCreated: number
  avgSessionDuration: string
}

export const ORG_ACTIVITY: OrgActivity[] = [
  // 总行部门
  { id: 'org-1', name: '零售金融部', level: 'head-dept', userCount: 286, activeUsers: 263, activeRate: 92, reportsCreated: 2345, avgSessionDuration: '15m 20s' },
  { id: 'org-2', name: '公司金融部', level: 'head-dept', userCount: 248, activeUsers: 218, activeRate: 88, reportsCreated: 2102, avgSessionDuration: '14m 05s' },
  { id: 'org-3', name: '风险管理部', level: 'head-dept', userCount: 156, activeUsers: 133, activeRate: 85, reportsCreated: 1890, avgSessionDuration: '13m 40s' },
  { id: 'org-4', name: '金融市场部', level: 'head-dept', userCount: 98, activeUsers: 71, activeRate: 72, reportsCreated: 1256, avgSessionDuration: '11m 15s' },
  { id: 'org-5', name: '运营管理部', level: 'head-dept', userCount: 312, activeUsers: 296, activeRate: 95, reportsCreated: 3210, avgSessionDuration: '16m 30s' },
  // 分行
  { id: 'org-6', name: '广州分行', level: 'branch', userCount: 520, activeUsers: 468, activeRate: 90, reportsCreated: 4520, avgSessionDuration: '14m 50s' },
  { id: 'org-7', name: '深圳分行', level: 'branch', userCount: 480, activeUsers: 418, activeRate: 87, reportsCreated: 3980, avgSessionDuration: '13m 20s' },
  { id: 'org-8', name: '佛山分行', level: 'branch', userCount: 198, activeUsers: 154, activeRate: 78, reportsCreated: 1680, avgSessionDuration: '10m 45s' },
  // 支行（分行下属）
  { id: 'org-9', name: '广州天河支行', level: 'sub-branch', userCount: 85, activeUsers: 79, activeRate: 93, reportsCreated: 780, avgSessionDuration: '15m 10s' },
  { id: 'org-10', name: '广州越秀支行', level: 'sub-branch', userCount: 72, activeUsers: 63, activeRate: 88, reportsCreated: 620, avgSessionDuration: '14m 20s' },
  { id: 'org-11', name: '深圳南山支行', level: 'sub-branch', userCount: 96, activeUsers: 87, activeRate: 91, reportsCreated: 890, avgSessionDuration: '15m 45s' },
  { id: 'org-12', name: '深圳福田支行', level: 'sub-branch', userCount: 88, activeUsers: 75, activeRate: 85, reportsCreated: 720, avgSessionDuration: '13m 50s' },
  { id: 'org-13', name: '佛山禅城支行', level: 'sub-branch', userCount: 54, activeUsers: 40, activeRate: 74, reportsCreated: 410, avgSessionDuration: '10m 30s' },
  { id: 'org-14', name: '佛山南海支行', level: 'sub-branch', userCount: 48, activeUsers: 35, activeRate: 73, reportsCreated: 350, avgSessionDuration: '9m 50s' },
]

/** 机构级别标签 */
const levelLabels: Record<OrgActivity['level'], string> = {
  'head-dept': '总行部门',
  branch: '分行',
  'sub-branch': '支行',
}

export { levelLabels }

// 处理日志
export interface ProcessingLog {
  id: string
  content: string
  createdAt: string
  action: 'start' | 'log' | 'close'
}

// 访问洞察
export interface AccessInsight {
  id: string
  type: 'hot-slow' | 'hot-data-quality' | 'cold-low-adoption' | 'hot-increasing' | 'anomaly'
  title: string
  description: string
  topic: string
  accessCount: number
  userCount: number
  trend: number
  issueTag?: string
  severity: 'high' | 'medium' | 'low'
  createdAt: string
  status: 'unhandled' | 'processing' | 'resolved'
  processingLogs: ProcessingLog[]
}

export const ACCESS_INSIGHTS: AccessInsight[] = [
  {
    id: 'insight-1',
    type: 'hot-slow',
    title: '代发工资业务响应速度需关注',
    description: '代发工资业务是近期用户关注的热点，近30天访问量达 2,340 次，但平均响应时间超过 8 秒，较系统平均水平慢 3 倍，建议重点关注性能优化。',
    topic: '代发客群营销分析',
    accessCount: 2340,
    userCount: 486,
    trend: 15,
    issueTag: '响应慢',
    severity: 'high',
    createdAt: '2026-06-05',
    status: 'unhandled',
    processingLogs: [],
  },
  {
    id: 'insight-2',
    type: 'hot-data-quality',
    title: '大额存款变动数据质量问题待解决',
    description: '大额存款变动情况是近期高频访问的数据，近30天访问量 1,890 次，但仍有数据质量问题未解决——部分客户金额字段存在异常值，影响分析结果准确性。',
    topic: '对公大额存款变动情况',
    accessCount: 1890,
    userCount: 312,
    trend: 8,
    issueTag: '数据质量问题',
    severity: 'high',
    createdAt: '2026-06-04',
    status: 'unhandled',
    processingLogs: [],
  },
  {
    id: 'insight-3',
    type: 'cold-low-adoption',
    title: '金融市场交易日报使用率偏低',
    description: '金融市场交易日报上线近1月仅有 5 人使用，累计访问量 23 次。该报表面向金融市场部全体用户（98人），使用率仅 5%，建议重点关注推广培训。',
    topic: '金融市场交易日报',
    accessCount: 23,
    userCount: 5,
    trend: -12,
    issueTag: '使用率低',
    severity: 'medium',
    createdAt: '2026-06-03',
    status: 'unhandled',
    processingLogs: [],
  },
  {
    id: 'insight-4',
    type: 'hot-increasing',
    title: '零售存款主题访问趋势上升',
    description: '零售存款相关主题近两周访问量持续上升，周环比增长 18%，主要由广州分行和深圳分行客户经理驱动，建议提前扩容保障性能。',
    topic: '零售存款主题',
    accessCount: 1560,
    userCount: 420,
    trend: 18,
    issueTag: '趋势上升',
    severity: 'low',
    createdAt: '2026-06-05',
    status: 'unhandled',
    processingLogs: [],
  },
  {
    id: 'insight-5',
    type: 'anomaly',
    title: '非工作时间访问量异常增加',
    description: '近一周非工作时间（22:00-06:00）访问量较前一周增长 45%，主要集中在深圳分行，建议排查是否存在异常访问或系统定时任务问题。',
    topic: '系统整体',
    accessCount: 342,
    userCount: 28,
    trend: 45,
    issueTag: '异常访问',
    severity: 'medium',
    createdAt: '2026-06-05',
    status: 'unhandled',
    processingLogs: [],
  },
]

// 高频访问报表 TOP 5
export const TOP_ACCESSED_REPORTS = [
  { name: '对公大额存款变动情况', accesses: 1890, users: 312, trend: 'up' as const },
  { name: '代发客群营销分析', accesses: 2340, users: 486, trend: 'up' as const },
  { name: '零售存款日报', accesses: 1230, users: 280, trend: 'stable' as const },
  { name: '客户资金流水分析', accesses: 980, users: 245, trend: 'up' as const },
  { name: '网点业绩看板', accesses: 856, users: 198, trend: 'down' as const },
]

// 低访问量报表 TOP 5
export const BOTTOM_ACCESSED_REPORTS = [
  { name: '金融市场交易日报', accesses: 23, users: 5, trend: 'down' as const, daysSinceLaunch: 28 },
  { name: '外汇交易周报', accesses: 34, users: 8, trend: 'stable' as const, daysSinceLaunch: 45 },
  { name: '理财产品销售分析', accesses: 56, users: 12, trend: 'down' as const, daysSinceLaunch: 32 },
  { name: '信贷资产质量分析', accesses: 67, users: 15, trend: 'stable' as const, daysSinceLaunch: 60 },
  { name: '中间业务收入分析', accesses: 89, users: 22, trend: 'up' as const, daysSinceLaunch: 15 },
]

// 用户反馈问题
export interface UserFeedbackIssue {
  id: string
  title: string
  description: string
  category: 'performance' | 'data-quality' | 'feature-request' | 'usability' | 'bug' | 'other'
  source: string
  reporterCount: number
  status: 'open' | 'in-progress' | 'transferred' | 'resolved' | 'closed'
  createdAt: string
  adminFeedback?: string
  feedbackAt?: string
  transferTarget?: 'data-governance' | 'branch-direct-train'
  transferAt?: string
  severity: 'critical' | 'high' | 'medium' | 'low'
}

const categoryLabels: Record<UserFeedbackIssue['category'], string> = {
  performance: '性能问题',
  'data-quality': '数据质量',
  'feature-request': '功能建议',
  usability: '使用体验',
  bug: '缺陷',
  other: '其他',
}

export const USER_FEEDBACK_ISSUES: UserFeedbackIssue[] = [
  {
    id: 'issue-1',
    title: '代发工资报表加载时间过长',
    description: '代发客群营销分析报表在筛选条件较多时加载时间超过10秒，严重影响日常使用体验，建议优化查询性能。',
    category: 'performance',
    source: '用户提交',
    reporterCount: 23,
    status: 'open',
    createdAt: '2026-06-03 14:30',
    severity: 'high',
  },
  {
    id: 'issue-2',
    title: '大额存款数据中部分客户金额字段存在异常值',
    description: '对公大额存款变动情况报表中，部分客户的交易金额显示为负数，与实际业务不符，疑似数据源存在问题。',
    category: 'data-quality',
    source: '系统分析提取',
    reporterCount: 15,
    status: 'open',
    createdAt: '2026-06-02 09:15',
    severity: 'high',
  },
  {
    id: 'issue-3',
    title: '希望增加按月汇总的代发客群分析视图',
    description: '当前代发客群分析报表仅有明细数据，缺少按月汇总的视图，建议增加月度汇总功能以便快速查看趋势。',
    category: 'feature-request',
    source: '用户提交',
    reporterCount: 8,
    status: 'open',
    createdAt: '2026-05-30 16:45',
    severity: 'medium',
  },
  {
    id: 'issue-4',
    title: '透视分析结果导出后格式错乱',
    description: '透视分析报表导出为Excel后，合并单元格和汇总行位置错乱，需要手动调整才能使用。',
    category: 'bug',
    source: '用户提交',
    reporterCount: 12,
    status: 'in-progress',
    createdAt: '2026-05-28 11:20',
    adminFeedback: '已定位到问题原因：导出模块在处理多级透视表时未正确计算合并单元格范围，正在修复中。',
    feedbackAt: '2026-05-29 10:00',
    severity: 'medium',
  },
  {
    id: 'issue-5',
    title: '系统首页加载缓慢',
    description: '近期每天上午9:00-9:30期间，系统首页加载时间明显变长，有时需要等待15秒以上才能显示。',
    category: 'usability',
    source: '用户提交',
    reporterCount: 31,
    status: 'open',
    createdAt: '2026-06-04 08:50',
    severity: 'critical',
  },
  {
    id: 'issue-6',
    title: '零售客户数据中联系电话格式不统一',
    description: '部分客户联系电话包含横杠、部分不含，部分包含国际区号，建议统一格式以便后续数据匹配。',
    category: 'data-quality',
    source: '系统分析提取',
    reporterCount: 6,
    status: 'open',
    createdAt: '2026-06-01 15:30',
    severity: 'low',
  },
]

export { categoryLabels }
